import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.122 10.5v4.655a.854.854 0 0 1-.838.838H3.838A.854.854 0 0 1 3 15.155V4.838C3 4.387 3.387 4 3.838 4h11.51c.355 0 .678.258.742.613.193 1.128 1.01 5.05-1.196 3.887S15.96 5 17.605 5.548c1.645.548 3.998 10.027 3.901 10.478-.128.419-.096.548-1.805 1.193-1.548.58-8.125 2.966-10.091 3.16a.606.606 0 0 1-.645-.388L8.394 18.5"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.394 8.42c-.376.69-.922 1.675-1.571.394-.649-1.28-1.093.099-1.57.64-.547.64-1.47-1.92-2.152-1.378-.683.541-1.024 2.708-1.707 1.625M10.394 11.815c-.598-1.28-1.007.098-1.447.64-.503.64-1.352-1.92-1.981-1.38-.629.543-.943 2.71-1.572 1.626"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AppointmentIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
